import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FlexLayoutModule} from "@angular/flex-layout";
import {SharedModule} from "../../../shared/shared.module";
import {ManageIntegrationsComponent} from "./manage.component";

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        SharedModule
    ],
    declarations: [
        ManageIntegrationsComponent
    ],
    exports: [ManageIntegrationsComponent],
    providers: []
})
export class ManageModule{}